import { jsx as _jsx } from "react/jsx-runtime";
import { ViewModelError } from '@atlassiansox/bxp-content-framework';
import { Page, UiAccordion, UiAddToSlackSection, UiAnimatedHeroSection, UiBlock, UiButton, UiCallout, UiCaption, UiCard, UiCarousel, UiColumn, UiContactForm, UiCookieBanner, UiCookiePreferences, UiDownloadButton, UiEmailSignup, UiFeatureSection, UiFooterNav, UiFooterNavBasic, UiGuide, UiHeaderNav, UiIcon, UiImage, UiImageSet, UiIntegration, UiIntegrationSection, UiLink, UiLinkBlock, UiListCarousel, UiLoginContainer, UiLoginSignupForm, UiMarkdown, UiMarketoForm, UiModal, UiNavBanner, UiNavBlogArticle, UiNavImages, UiNavLink, UiPowerUp, UiPricingCalculator, UiPricingComparisonTable, UiPricingGrid, UiQuote, UiRecommendShare, UiRotatingImages, UiRotatingItems, UiSection, UiSectionGroup, UiSocialLoginSignupButton, UiSocialProof, UiSocialShare, UiSpacer, UiStack, UiStatuspage, UiStoryline, UiTemplateGallery, UiTextBlock, UiTooltip, UiTrelloBoard, UiValueProp, UiVariationContainer, UiVideo, UiVideoPlayer, UiWebinarLink, UiWorkspacePicker } from './views';
/**
 * TODO: view models should be rendered automatically by the framework
 */
/**
 * TODO: add Sentry error boundary with tags
 * scope.setTags({team: 'bxpt', modelType: viewModel.type, contentId: viewModel.id})
 */
export function renderViewModel(viewModel) {
    switch (viewModel.type) {
        case 'page':
            return _jsx(Page, { model: viewModel }, viewModel.id);
        case 'uiAccordion':
            return _jsx(UiAccordion, { model: viewModel }, viewModel.id);
        case 'uiAddToSlackSection':
            return _jsx(UiAddToSlackSection, { model: viewModel }, viewModel.id);
        case 'uiAnimatedHeroSection':
            return _jsx(UiAnimatedHeroSection, { model: viewModel }, viewModel.id);
        case 'uiBlock':
            return _jsx(UiBlock, { model: viewModel }, viewModel.id);
        case 'uiButton':
            return _jsx(UiButton, { model: viewModel }, viewModel.id);
        case 'uiCallout':
            return _jsx(UiCallout, { model: viewModel }, viewModel.id);
        case 'uiCaption':
            return _jsx(UiCaption, { model: viewModel }, viewModel.id);
        case 'uiCard':
            return _jsx(UiCard, { model: viewModel }, viewModel.id);
        case 'uiCarousel':
            return _jsx(UiCarousel, { model: viewModel }, viewModel.id);
        case 'uiColumn':
            return _jsx(UiColumn, { model: viewModel }, viewModel.id);
        case 'uiContactForm':
            return _jsx(UiContactForm, { model: viewModel }, viewModel.id);
        case 'uiCookieBanner':
            return _jsx(UiCookieBanner, { model: viewModel }, viewModel.id);
        case 'uiCookiePreferences':
            return _jsx(UiCookiePreferences, { model: viewModel }, viewModel.id);
        case 'uiDownloadButton':
            return _jsx(UiDownloadButton, { model: viewModel }, viewModel.id);
        case 'uiEmailSignup':
            return _jsx(UiEmailSignup, { model: viewModel }, viewModel.id);
        case 'uiFeatureSection':
            return _jsx(UiFeatureSection, { model: viewModel }, viewModel.id);
        case 'uiFooterNav':
            return _jsx(UiFooterNav, { model: viewModel }, viewModel.id);
        case 'uiFooterNavBasic':
            return _jsx(UiFooterNavBasic, { model: viewModel }, viewModel.id);
        case 'uiGuide':
            return _jsx(UiGuide, { model: viewModel }, viewModel.id);
        case 'uiHeaderNav':
            return _jsx(UiHeaderNav, { model: viewModel }, viewModel.id);
        case 'uiIcon':
            return _jsx(UiIcon, { model: viewModel }, viewModel.id);
        case 'uiImage':
            return _jsx(UiImage, { model: viewModel }, viewModel.id);
        case 'uiImageSet':
            return _jsx(UiImageSet, { model: viewModel }, viewModel.id);
        case 'uiIntegration':
            return _jsx(UiIntegration, { model: viewModel }, viewModel.id);
        case 'uiIntegrationSection':
            return _jsx(UiIntegrationSection, { model: viewModel }, viewModel.id);
        case 'uiLoginContainer':
            return _jsx(UiLoginContainer, { model: viewModel }, viewModel.id);
        case 'uiLoginSignupForm':
            return _jsx(UiLoginSignupForm, { model: viewModel }, viewModel.id);
        case 'uiLink':
            return _jsx(UiLink, { model: viewModel }, viewModel.id);
        case 'uiLinkBlock':
            return _jsx(UiLinkBlock, { model: viewModel }, viewModel.id);
        case 'uiListCarousel':
            return _jsx(UiListCarousel, { model: viewModel }, viewModel.id);
        case 'uiMarkdown':
            return _jsx(UiMarkdown, { model: viewModel }, viewModel.id);
        case 'uiMarketoForm':
            return _jsx(UiMarketoForm, { model: viewModel }, viewModel.id);
        case 'uiModal':
            return _jsx(UiModal, { model: viewModel }, viewModel.id);
        case 'uiNavBanner':
            return _jsx(UiNavBanner, { model: viewModel }, viewModel.id);
        case 'uiNavBlogArticle':
            return _jsx(UiNavBlogArticle, { model: viewModel }, viewModel.id);
        case 'uiNavImages':
            return _jsx(UiNavImages, { model: viewModel }, viewModel.id);
        case 'uiNavLink':
            return _jsx(UiNavLink, { model: viewModel }, viewModel.id);
        case 'uiPowerUp':
            return _jsx(UiPowerUp, { model: viewModel }, viewModel.id);
        case 'uiPricingCalculator':
            return _jsx(UiPricingCalculator, { model: viewModel }, viewModel.id);
        case 'uiPricingComparisonTable':
            return _jsx(UiPricingComparisonTable, { model: viewModel }, viewModel.id);
        case 'uiPricingGrid':
            return _jsx(UiPricingGrid, { model: viewModel }, viewModel.id);
        case 'uiQuote':
            return _jsx(UiQuote, { model: viewModel }, viewModel.id);
        case 'uiRecommendShare':
            return _jsx(UiRecommendShare, { model: viewModel }, viewModel.id);
        case 'uiRotatingImages':
            return _jsx(UiRotatingImages, { model: viewModel }, viewModel.id);
        case 'uiRotatingItems':
            return _jsx(UiRotatingItems, { model: viewModel }, viewModel.id);
        case 'uiSection':
            return _jsx(UiSection, { model: viewModel }, viewModel.id);
        case 'uiSectionGroup':
            return _jsx(UiSectionGroup, { model: viewModel }, viewModel.id);
        case 'uiSocialLoginSignupButton':
            return _jsx(UiSocialLoginSignupButton, { model: viewModel }, viewModel.id);
        case 'uiSocialProof':
            return _jsx(UiSocialProof, { model: viewModel }, viewModel.id);
        case 'uiSocialShare':
            return _jsx(UiSocialShare, { model: viewModel }, viewModel.id);
        case 'uiSpacer':
            return _jsx(UiSpacer, { model: viewModel }, viewModel.id);
        case 'uiStack':
            return _jsx(UiStack, { model: viewModel }, viewModel.id);
        case 'uiStatuspage':
            return _jsx(UiStatuspage, { model: viewModel }, viewModel.id);
        case 'uiStoryline':
            return _jsx(UiStoryline, { model: viewModel }, viewModel.id);
        case 'uiTemplateGallery':
            return _jsx(UiTemplateGallery, { model: viewModel }, viewModel.id);
        case 'uiTextBlock':
            return _jsx(UiTextBlock, { model: viewModel }, viewModel.id);
        case 'uiTrelloBoard':
            return _jsx(UiTrelloBoard, { model: viewModel }, viewModel.id);
        case 'uiTooltip':
            return _jsx(UiTooltip, { model: viewModel }, viewModel.id);
        case 'uiValueProp':
            return _jsx(UiValueProp, { model: viewModel }, viewModel.id);
        case 'uiVariationContainer':
            return _jsx(UiVariationContainer, { model: viewModel }, viewModel.id);
        case 'uiVideo':
            return _jsx(UiVideo, { model: viewModel }, viewModel.id);
        case 'uiVideoPlayer':
            return _jsx(UiVideoPlayer, { model: viewModel }, viewModel.id);
        case 'uiWebinarLink':
            return _jsx(UiWebinarLink, { model: viewModel }, viewModel.id);
        case 'uiWorkspacePicker':
            return _jsx(UiWorkspacePicker, { model: viewModel }, viewModel.id);
        default:
            return _jsx(ViewModelError, { model: viewModel }, `${Date.now()}`);
    }
}
export function renderViewModels(viewModels) {
    return viewModels.map(renderViewModel);
}
//# sourceMappingURL=render-view-model.js.map